import React from 'react';
import { motion } from 'framer-motion';
import { WindIcon, SparklesIcon, StarIcon, ArrowRightIcon, WineIcon } from 'lucide-react';
const previewCards = [{
  icon: <WindIcon size={24} data-id="element-434" />,
  title: 'MK HOOKAH',
  tag: 'FROM $15',
  tagStyle: 'border border-[#C9A84C]/40 text-[#C9A84C]',
  description: 'The highest quality hookah in DC. AL-FAKHER, STARBUZZ & ADALYA flavours available.',
  accent: 'rgba(201,168,76,0.06)',
  border: '1px solid #2A2622'
}, {
  icon: <SparklesIcon size={24} data-id="element-435" />,
  title: 'GOLD PACKAGE',
  tag: '$700',
  tagStyle: 'bg-[#C9A84C] text-[#050505]',
  description: 'Two bottles top shelf liquor, house champagne & hookah. 6 guests free entry.',
  accent: 'rgba(201,168,76,0.08)',
  border: '1px solid rgba(201,168,76,0.3)'
}, {
  icon: <StarIcon size={24} data-id="element-436" />,
  title: 'PLATINUM',
  tag: 'MOST POPULAR',
  tagStyle: 'bg-[#C9A84C] text-[#050505]',
  description: 'Two bottles top shelf, Belair Rosé, hookah & hookah head. 8 guests free entry.',
  accent: 'rgba(201,168,76,0.1)',
  border: '1px solid rgba(201,168,76,0.4)'
}];
const bottlePreview = [{
  name: 'Black Label',
  price: '$230'
}, {
  name: 'Casamigos',
  price: '$300'
}, {
  name: 'Don Julio 1942',
  price: '$500'
}, {
  name: 'Hennessy V.S',
  price: '$230'
}, {
  name: 'CÎROC',
  price: '$230'
}];
export function SeatingOptions({
  onViewPackages
}: {
  onViewPackages: () => void;
}) {
  return <section id="seating" className="w-full bg-[#050505] py-20 px-4 sm:px-6" data-id="element-437">
      <div className="max-w-7xl mx-auto" data-id="element-438">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-439">
          <span className="font-inter text-[11px] tracking-[0.4em] text-[#C9A84C]/60 uppercase" data-id="element-440">
            Packages & Services
          </span>
          <h2 className="font-montserrat font-black text-3xl sm:text-4xl lg:text-5xl tracking-widest text-white mt-2" data-id="element-441">
            CHOOSE YOUR VIBE
          </h2>
          <div className="w-14 h-px bg-[#C9A84C]/50 mx-auto mt-4 mb-5" data-id="element-442" />
          <p className="font-inter font-light text-white/50 text-[15px] max-w-xl mx-auto leading-relaxed" data-id="element-443">
            Premium hookah, exclusive bottle packages, and VIP table service —
            everything you need for an unforgettable night.
          </p>
        </motion.div>

        {/* Preview Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-444">
          {previewCards.map((card, i) => <motion.div key={card.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} onClick={onViewPackages} className="rounded-2xl p-6 cursor-pointer group transition-all duration-300 hover:scale-[1.02]" style={{
          background: card.accent,
          border: card.border,
          boxShadow: '0 8px 40px rgba(0,0,0,0.5)'
        }} data-id="element-445">
              <div className="flex items-start justify-between mb-4" data-id="element-446">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center text-[#C9A84C] group-hover:scale-110 transition-transform duration-300" style={{
              background: 'rgba(201,168,76,0.12)',
              border: '1px solid rgba(201,168,76,0.2)'
            }} data-id="element-447">
                  {card.icon}
                </div>
                <span className={`font-montserrat font-black text-[9px] tracking-widest px-2.5 py-1 rounded-full ${card.tagStyle}`} data-id="element-448">
                  {card.tag}
                </span>
              </div>
              <h3 className="font-montserrat font-black text-lg tracking-widest text-white mb-2 group-hover:text-[#C9A84C] transition-colors duration-300" data-id="element-449">
                {card.title}
              </h3>
              <p className="font-inter text-sm text-white/45 leading-relaxed mb-4" data-id="element-450">
                {card.description}
              </p>
              <div className="flex items-center gap-2 text-[#C9A84C]/60 group-hover:text-[#C9A84C] transition-colors" data-id="element-451">
                <span className="font-montserrat font-700 text-[11px] tracking-widest" data-id="element-452">
                  VIEW DETAILS
                </span>
                <ArrowRightIcon size={12} className="group-hover:translate-x-1 transition-transform" data-id="element-453" />
              </div>
            </motion.div>)}
        </div>

        {/* Bottle Preview Strip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="rounded-2xl p-5 mb-8" style={{
        background: '#0d0b09',
        border: '1px solid #2A2622'
      }} data-id="element-454">
          <div className="flex items-center gap-3 mb-4" data-id="element-455">
            <WineIcon size={16} className="text-[#C9A84C]" data-id="element-456" />
            <span className="font-montserrat font-black text-[11px] tracking-widest text-white/50" data-id="element-457">
              FEATURED BOTTLES
            </span>
          </div>
          <div className="flex gap-3 overflow-x-auto hide-scrollbar pb-1" data-id="element-458">
            {bottlePreview.map(b => <div key={b.name} className="flex-shrink-0 flex items-center gap-3 rounded-xl px-4 py-2.5" style={{
            background: 'rgba(201,168,76,0.05)',
            border: '1px solid rgba(201,168,76,0.12)'
          }} data-id="element-459">
                <span className="font-montserrat font-700 text-xs tracking-wider text-white/70" data-id="element-460">
                  {b.name}
                </span>
                <span className="font-montserrat font-black text-sm text-[#C9A84C]" data-id="element-461">
                  {b.price}
                </span>
              </div>)}
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center" data-id="element-462">
          <button onClick={onViewPackages} className="group inline-flex items-center gap-3 font-montserrat font-black text-[13px] tracking-widest bg-[#C9A84C] text-[#050505] px-8 py-4 rounded-xl hover:bg-[#E8C97A] transition-all duration-300" style={{
          boxShadow: '0 4px 20px rgba(201,168,76,0.25)'
        }} data-id="element-463">
            VIEW ALL PACKAGES & SERVICES
            <ArrowRightIcon size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-464" />
          </button>
        </motion.div>
      </div>
    </section>;
}